<template>

  <section class="pt-0" v-if="$root.instance">

    <form v-on:submit.prevent="proceed">

      <template v-for="(tour_booking, tour_booking_index) of $root.booking.tour_bookings">

        <h5 :key="'heading' + tour_booking_index">Passengers for {{ tour_booking.room.name }} at {{ tour_booking.room.accommodation.details.accommodation_name }} ({{ tour_booking.room.board_basis }})</h5>
        <p style="color:red; margin: 25px 0px 25px 0px;"> <sup>**</sup> Passenger names must be as they shown on the passport (middle names are not required). <sup>**</sup> </p>
        <table :key="'table' + tour_booking_index" class="table" cellspacing="0" cellpadding="0">

          <thead>
            <tr>
              <th>Title</th>
              <th>First name</th>
              <th>Last name</th>
              <th>DOB</th>
            </tr>
          </thead>
          
          <tbody>
            <template v-for="( passenger,  index) of tour_booking.passengers">
              <!-- Add title row based on occupancy and loop index -->
              <tr :key="passenger.id" v-if="index % tour_booking.room.occupancy === 0">
                <td :colspan="4" class="text-center" style="vertical-align: middle;">Passengers for Room {{ index === 0 ? index+1 : (index/tour_booking.room.occupancy)+1 }}</td>
              </tr>
              <!-- Render the passenger details -->
              <tr :key="passenger.id">
                <td><v-select v-model="passenger.title" :options="['Mr', 'Mrs', 'Miss', 'Master', 'Ms', 'Mx', 'Dr', 'Prof']" required></v-select></td>
                <td><input class="form-control" type="text" v-model="passenger.first_name" required></td>
                <td><input class="form-control" type="text" v-model="passenger.last_name" required></td>
                <td><date-picker v-model="passenger.dob" name="passenger.dob" type="date" format="DD/MM/YYYY"
              date-format="DD/MM/YYYY" valueType="YYYY-MM-DD" /></td>
              </tr>
            </template>
          </tbody>

        </table>
      </template>

      <br><br>

      <button type="submit" class="btn btn-primary">Next</button>

    </form>

  </section>
  
</template>
<style>.mx-datepicker input { height: calc(2.375rem + 2px); } .mx-datepicker {width: 120px;}</style>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: 'Passengers',
  components: {
    DatePicker
  },
  data() {
    return {
      occupancy: 2
    }
  },
  methods: {
    proceed: function () {
      this.$router.push({ name: 'customer' })
      $("html, body").animate({ scrollTop: 0 }, "slow");
    },
  },
  computed: {
    thisYear: function () {
      return new Date().toISOString().substring(0,10);
    }
  },
  mounted () {
    // send to beginning if arrived early at this step somehow
    if(this.$root.booking.tour_bookings.length < 1) {
      this.$router.push({ name: 'accommodation' })
    }
  }
}
</script>